// extracted by mini-css-extract-plugin
module.exports = {"division":"Division_division__3Ae7U","title":"Division_title__5l0E9"};